import React from 'react';
import PropTypes from 'prop-types';
//import "react-table/react-table.css";
import EditableGrid2 from "./EditableGrid2";

class ExpenseGrid extends React.PureComponent {
  constructor(props) {
    super(props);
    this.grid = React.createRef();

    this._handleBasicValueChange = this._handleBasicValueChange.bind(this);
  }

  _handleBasicValueChange({ rowData, column, value }) {
    if (column.type === "number") {
      value = 1* value;
    }
    this.props.onExpenseUpdate(rowData, { [column.dataKey]: value});
  }

  render() {

    const columns = [{
      key: 'name',
      dataKey: 'name',
      title: 'Code Name (Read Only)',
      width: 200,
      resizable: true,
      type: "stringReadOnly",
      onValueChange: this._handleBasicValueChange
    },{
      key: 'label',
      dataKey: 'label',
      title: 'Label',
      width: 200,
      resizable: true,
      type: "string",
      onValueChange: this._handleBasicValueChange
    }];

    return (
      <EditableGrid2
        columns={columns}
        data={this.props.expenses}
        onNewRowClick={this.props.onNewRowClick}
        onSelectionChange={this.props.onSelectionChange}
        selectionStorage={this.props.selectionStorage}
        menuId={this.props.menuId}
        uuidKey="name"
      />

    );

  }
}

ExpenseGrid.propTypes = {
  expenses: PropTypes.array.isRequired,
  version: PropTypes.number.isRequired,
  onExpenseUpdate: PropTypes.func.isRequired,
  onNewRowClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func,
  selectionStorage: PropTypes.object,
  menuId: PropTypes.string
}

export default ExpenseGrid;